import React from "react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
import { CurrencyNote } from "./CurrencyNote";
import { images, PRICE, TOTAL_VALUE } from "../data/offer";
export function OfferSection() {
  return <section className="bg-navy-950 px-4 py-16 text-white sm:px-6 sm:py-24" id="offer" data-id="element-257" data-mp="ddvefav8e7cg">
      <div className="mx-auto max-w-3xl text-center" data-id="element-258" data-mp="id8ckrrjz0uc">
        <p className="font-display text-xl font-semibold uppercase tracking-wide text-accent" data-id="element-259" data-mp="icgglfu1n13j">The special offer</p>
        <h2 className="mt-2 font-display text-[2.2rem] font-bold uppercase leading-[1.05] sm:text-5xl" data-id="element-260" data-mp="md0cyh6sm0om">
          Get the complete blueprint for <span className="text-cta" data-id="element-261" data-mp="wczo8lulk556">${PRICE}</span>
        </h2>
        <p className="mt-4 text-lg text-white/80" data-id="element-262" data-mp="wc7znuzf37oe">
          The offer displayed on this page is ${PRICE} USD for the complete six-volume collection and five bonuses.
        </p>

        <img src={images.mockup} alt="" className="mx-auto mt-6 w-full max-w-xl" loading="lazy" data-id="element-263" data-mp="2y55ozgtzji4l" />

        <div className="mt-4 flex items-end justify-center gap-4" data-id="element-264" data-mp="12oa78rpgq1hn">
          <span className="pb-2 font-display text-3xl font-bold text-white/60 line-through" data-id="element-265" data-mp="xwa0afaz68bk">${TOTAL_VALUE}</span>
          <span className="font-display text-7xl font-bold leading-none text-cta sm:text-8xl" data-id="element-266" data-mp="swxd1tg6yz8g">${PRICE}</span>
        </div>
        <p className="mt-2 font-semibold" data-id="element-267" data-mp="oxonl0s6pnip">One-time payment · No monthly fees</p>
      </div>

      <div className="mx-auto mt-8 flex max-w-3xl flex-col gap-8" data-id="element-268" data-mp="1ll338vq0lgfo">
        <CtaButton label={`Get instant access — $${PRICE}`} tone="dark" data-id="element-269" data-mp="1gmrt0jvt53wx" />
        <Countdown data-id="element-270" data-mp="1glglc8z8rc0j" />
        <ScarcityBar data-id="element-271" data-mp="1cl6jn8ihf7rh" />
        <CurrencyNote data-id="element-272" data-mp="1ckn23swquldz" />
        <p className="text-center text-sm text-white/65" data-id="element-273" data-mp="1ck4y2a3ub2vi">
          If you choose to purchase, review the product description and checkout terms before completing your order.
        </p>
      </div>
    </section>;
}